import React from 'react';
import Header, { BreadcrumbItem } from '../components/Header';
import { useAuth } from '../context/AuthContext';
import { usePageTracking } from '../hooks/usePageTracking';
import { AssessmentProvider } from '../context/AssessmentContext';
import AssessmentFlow from '../components/AssessmentFlow';
import styles from '../styles/selfAssessPage.module.css';

interface SelfAssessPageProps {
  user?: any;
  onLogout: () => void;
  onLogin: () => void;
}

const SelfAssessPage: React.FC<SelfAssessPageProps> = ({ user, onLogout, onLogin }) => {
  const { forceClearAuth } = useAuth();
  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Home', path: '/', active: false },
    { label: 'Self Assessment', path: '/self-assess', active: true }
  ];

  // Track page visit
  usePageTracking('Am I an Addict?');

  return (
    <div className={styles.selfAssessPage}>
      <Header 
        breadcrumbs={breadcrumbs}
        user={user}
        onLogout={onLogout}
        onLogin={onLogin}
      />
      
      <main className={styles.mainContent}>
        <AssessmentProvider>
          <AssessmentFlow />
        </AssessmentProvider>
      </main>
    </div>
  );
};

export default SelfAssessPage;
